import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DFMonthlyDataDto } from '../shared/df-admin-country.model';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {
  private calendarBoolean = new Subject<boolean>();
  private editableCalendar = new Subject<boolean>();
  calendarVal$ = this.calendarBoolean.asObservable();
  editCalendarVal$ = this.editableCalendar.asObservable();
  private calendarDataSource = new BehaviorSubject<any>({});
  calendarData$ = this.calendarDataSource.asObservable();
  private selectedYear: number;
  private selectedCountry: string;
  private formType: string;

  constructor() { }

  setCalendarData(updatedmonths: DFMonthlyDataDto[], year: number, bufferDays = '') {
    this.calendarDataSource.next({ months: updatedmonths, year, bufferDays });
  }

  sendCalendarValue(calendarVal: boolean) {
    this.calendarBoolean.next(calendarVal)
  }

  setEditableCalendar(editValue: boolean) {
    this.editableCalendar.next(editValue);
  }
  setSelectedYear(year: number) {
    this.selectedYear = year;
  }

  getSelectedYear(): number {
    return this.selectedYear;
  }

  setSelectedCountry(country: string) {
    if (country) {
      this.selectedCountry = country;
    }
  }

  getSelectedCountry(): string {
    return this.selectedCountry;
  }

  getFormType(): string {
    return this.formType;
  }

  setFormType(formType: string) {
    this.formType = formType;
  }
}
